import  View from 'views/base/view';
import CourseSettingsService from 'services/course-settings-service';
import SessionService from 'services/session-service';

export default class GuidesOverlayView extends View {
  constructor(options) {
    super(options);
    this.autoRender = false;
    this.noWrap = true;
    if(CourseSettingsService.get('guides')) {
      let guides = CourseSettingsService.get('guides').filter(g => g.enabled === true).map(g => {
        let clone = Object.assign({}, g);
        delete clone.enabled;
        return clone;
      });
      this.model = new Chaplin.Model({guides: guides});
    }
    this.subscribeEvent('addedToDOM', this.load);
    SessionService.set('overlayEnabled', true);
  }

  load() {
    this.delegate('click', '.guides-close', () => {
      SessionService.remove('overlayEnabled');
      this.dispose();
    });
  }

  render() {
    if(this.model) {
      let template = require('./templates/guides-overlay');
      this.$el = $(template(this.model.attributes));
    }
  }

  attach() {
    $('body').prepend(this.$el);
    this.publishEvent('addedToDOM');
  }
}
